import React from 'react';

/**
 * Sirf is IMEI par save unit seller dikhata hai.
 * Koi product-level fallback nahi (galat record avoid).
 */
export function formatImeiSellerSummary(_product, imei) {
  const un = typeof imei?.unitSeller?.sellerName === 'string' ? imei.unitSeller.sellerName.trim() : '';
  if (un) return un;
  const up = typeof imei?.unitSeller?.sellerPhone === 'string' ? imei.unitSeller.sellerPhone.trim() : '';
  if (up) return up;
  return '';
}

/**
 * Transfer-in unit ke liye branch override price ya "Listing" dikhata hai.
 */
export function formatImeiBranchPriceSummary(product, imei) {
  if (!imei?.transferIn?.fromBranchId) return '—';
  const list = Number(imei.transferListPrice);
  const off = Number(imei.transferOfferPrice);
  const bits = [];
  if (!Number.isNaN(list) && list > 0) bits.push(`₹${list.toLocaleString('en-IN')}`);
  if (!Number.isNaN(off) && off > 0) bits.push(`off ₹${off.toLocaleString('en-IN')}`);
  if (bits.length) return bits.join(' · ');
  return (
    <span className="text-muted" title="Product listing price">
      Listing ₹{Number(product?.price || 0).toLocaleString('en-IN')}
    </span>
  );
}

function eventSortTime(ev) {
  const d = ev?.at || ev?.archivedAt || ev?.saleDate;
  return d ? new Date(d).getTime() : 0;
}

/** Merge unitHistory + legacy lastBuyback for display (oldest first). */
export function getImeiUnitHistoryEvents(imei) {
  const events = Array.isArray(imei?.unitHistory) ? [...imei.unitHistory] : [];
  const hasBuyback = events.some((e) => e?.type === 'buyback');
  if (!hasBuyback && imei?.lastBuyback?.price != null) {
    events.push({
      type: 'buyback',
      ...imei.lastBuyback,
      _legacyOnly: true
    });
  }
  return events.sort((a, b) => eventSortTime(a) - eventSortTime(b));
}

export function formatInr(n) {
  if (n == null || Number.isNaN(Number(n))) return '—';
  return `₹${Number(n).toLocaleString('en-IN')}`;
}

export function formatHistoryDate(ev) {
  const d = ev?.at || ev?.archivedAt || ev?.saleDate;
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-IN');
}
